import * as React from 'react';
import { connect } from 'react-redux';
import { setPlanes, setId, setDataGrupo, setPlanesDesdeBusqueda, setEditando, fetchGrupoPlanes, setFiltroGrupoPlanes } from '../../actions/planesActions';
import { postGrupoPlanes } from '../../api/axios';
import { toast } from 'react-toastify';
import Cleave from 'cleave.js/react';
import GoBackArrow from '../General/GoBackArrow';
import { withNavigation } from '../General/withNavigation';

class PlanesNew extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            request: null,
            descripcion: "",
            comision: 0,
        };
        this.descripcionInputRef = React.createRef();
    };

    componentDidMount() {
        this.setState({
            request: this.props.planes
        });

        if (this.descripcionInputRef.current) {
            this.descripcionInputRef.current.focus();
        }
    }

    onSubmit = async (event) => {
        event.preventDefault();
        if (this.props.dataGrupo.descripcion == "" || this.props.dataGrupo.comision == "") {
            if (this.props.dataGrupo.descripcion == "") {
                toast.error("Debe agregar una descripción");
            }
            if (this.props.dataGrupo.comision == "") {
                toast.error("Debe agregar una comisión");
            }
            return;
        }
        let idPlanes = [];
        for (let index = 0; index < this.props.planDesdeBusqueda.length; index++) {
            idPlanes.push(this.props.planDesdeBusqueda[index].id);
        }

        if (JSON.stringify(idPlanes) == "[]") {
            toast.error("Debe agregar planes");
            return;
        }
        let data = {
            descripcion: this.props.dataGrupo.descripcion,
            comision: parseFloat(this.props.dataGrupo.comision),
            listaIdsPlanes: idPlanes
        }

        let post = postGrupoPlanes(data);
        post.then(res => {
            toast.success("Grupo de planes guardado");
            this.return();
        }).catch(err => {
            toast.error("No pudo guardarse");
        });

    }

    borrarFila = (item) => {
        let index = this.props.planDesdeBusqueda.findIndex(x => x.numero == item.numero);
        this.props.planDesdeBusqueda.splice(index, 1);
        this.props.setPlanesDesdeBusqueda(this.props.planDesdeBusqueda)
        this.forceUpdate();
    }


    renderPlanesLista = () => {
        const list = this.props.planDesdeBusqueda;
        if (!list?.length) return null;
        return (
            <div className="admin-list-stack mt-3">
                <label className="label-oscura d-block mb-2">Planes seleccionados</label>
                {list.map((item, idx) => (
                    <div key={item.numero ?? idx} className="admin-list-card p-3 admin-list-card--vigente">
                        <div className="row g-2 align-items-center">
                            <div className="col-auto">
                                <span className="admin-id-badge">{item.numero}</span>
                            </div>
                            <div className="col text-break">
                                <div className="admin-list-card__title fw-semibold small mb-0">{item.descripcion}</div>
                            </div>
                            <div className="col-auto">
                                <button
                                    type="button"
                                    className="btn btn-link btn-sm text-danger p-0"
                                    onClick={() => this.borrarFila(item)}
                                    aria-label="Quitar plan"
                                >
                                    <i className="fas fa-trash-alt" />
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    myChangeHandler = (e) => {
        var numbersOnly = /^[0-9.]+$/;
        let valor = e.target.value;

        if (e.target.name == "comision") {
            let esNumero = valor.match(numbersOnly);
            if (esNumero == null) {
                document.getElementById("comisionId").value = "";
                return;
            }
            if (e.target.value > 100) {
                document.getElementById("comisionId").value = "";
            } else {
                this.props.setDataGrupo({ ...this.props.dataGrupo, [e.target.name]: e.target.value })
            }
        } else {
            this.props.setDataGrupo({ ...this.props.dataGrupo, [e.target.name]: e.target.value })
        }
    }



    goToBusqueda = () => {
        this.props.setEditando(false);
        this.props.setId("Nuevo");
        this.props.navigate("/Planes/Busqueda");
    }
    return = async () => {
        this.props.setPlanesDesdeBusqueda([]);
        this.props.setPlanes([]);

        // 1) dejá el filtro limpio en Redux (página 1, tamaño 10)
        const newFilter = {
            descripcion: '',
            page: 1,
            pageSize: 10,
            showFilter: this.props.filtro?.showFilter ?? false
        };
        this.props.setFiltroGrupoPlanes(newFilter);

        // 2) pedí la lista con ese filtro
        await this.props.fetchGrupoPlanes({ params: newFilter });

        // 3) navegá al listado
        this.props.navigate("/Planes");
    }



    render() {

        return (

            <div className="container py-2">
                <div className="card admin-grupo-busqueda-shell border-0 bg-white">
                    <div className="admin-grupo-busqueda-header">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-2">
                            <div className="d-flex align-items-center gap-2">
                                <GoBackArrow />
                                <div>
                                    <h4 className="mb-0 text-body fw-semibold">Nuevo grupo de planes</h4>
                                    <p className="small text-body-secondary mb-0 mt-1 d-none d-md-block">Definí comisión y agregá al menos un plan.</p>
                                </div>
                            </div>
                            <button type="button" onClick={this.goToBusqueda} className="btn btn-sm background-rojo-megatone">
                                <i className="fa fa-plus-circle me-1" /> Agregar planes
                            </button>
                        </div>
                    </div>

                    <div className="px-4 pb-4 pt-2">
                        <form className="form-horizontal form-material" onSubmit={this.onSubmit}>
                            <div className="tab-content">

                                <div class="form-group">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <label className="label-oscura">Descripción</label>
                                            <input
                                                name="descripcion"
                                                type="text"
                                                value={this.props.dataGrupo.descripcion}
                                                onChange={this.myChangeHandler}
                                                id="firstName"
                                                class="form-control"
                                                ref={this.descripcionInputRef}
                                            />
                                        </div>
                                        <div class="col-md-6">
                                            <small className=" font-14  applyFont"><i className="fas fa-percent"></i></small>
                                            <label className="label-oscura">&ensp;Comisión</label>
                                            <Cleave id="comisionId" name="comision" value={this.props.dataGrupo.comision == 100 ? 100 : this.props.dataGrupo.comision} onKeyUp={this.myChangeHandler} className="form-control"
                                                options={{ blocks: [5], numericOnly: false }} />
                                        </div>
                                    </div>
                                </div>

                                {this.renderPlanesLista()}

                                <div className="d-flex justify-content-center flex-wrap gap-2 mt-4 pt-3 border-top">
                                    <button type="submit" className="btn btn-sm background-rojo-megatone px-4">Guardar</button>
                                    <button type="button" onClick={this.return} className="btn btn-sm btn-light">Cancelar</button>
                                </div>
                            </div>
                        </form>
                    </div>

                </div>
            </div>

        );
    }

}


const mapStateToProps = state => (
    {
        dataGrupo: state.planes.dataGrupo,
        planes: state.planes,
        planDesdeBusqueda: state.planes.planesDesdeBusqueda,
        filtro: state.planes.filtro
    });
export default withNavigation(connect(mapStateToProps, { fetchGrupoPlanes, setEditando, setPlanes, setId, setDataGrupo, setPlanesDesdeBusqueda, setFiltroGrupoPlanes })(PlanesNew));  